<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent max-width="800px">
      <v-card :loading="loading" :disabled="cardDisabled">
        <v-card-title>
          <span class="headline">{{ $t("New Token") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-alert
              text
              prominent
              dismissible
              v-model="alertShow"
              type="error"
              icon="mdi-alert"
              >{{ alertText }}</v-alert
            >
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :label="descriptionLabel"
                    :rules="descriptionRules"
                    :error-messages="errorMessages"
                    v-model="description"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    :items="roles"
                    item-text="name"
                    item-value="id"
                    v-model="selectedRoles"
                    :no-data-text="rolesNoDataLabel"
                    :label="rolesLabel"
                    chips
                    deletable-chips
                    multiple
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-radio-group v-model="expirationDateType" mandatory row>
                    <v-radio
                      :label="noExpirationLabel"
                      value="lifetime"
                    ></v-radio>
                    <v-radio
                      :label="expirationDateLabel"
                      value="expirationDate"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" v-show="datePickerShow">
                  <v-date-picker
                    v-model="datePicker"
                    :locale="locale"
                    reactive
                    show-current
                    :min="datePickerMinimum"
                    type="date"
                  ></v-date-picker>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="hide">{{ $t("close") }}</v-btn>
          <v-btn
            color="darken-1"
            text
            @click="createToken"
            :disabled="!valid"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import i18n from "../../../i18n";
import EventBus from "../../../event-bus";

export default {
  name: "NewUserModal",
  props: {},
  data: () => ({
    valid: true,
    showModal: false,
    loading: true,
    cardDisabled: true,
    alertText: null,
    alertShow: false,
    description: "",
    descriptionLabel: i18n.t("Description"),
    noExpirationLabel: i18n.t("No expiration"),
    expirationDateLabel: i18n.t("Expiration Date"),
    errorMessages: [],
    descriptionRules: [],
    roles: [],
    rolesLabel: i18n.t("Roles"),
    rolesNoDataLabel: i18n.t("No roles available"),
    selectedRoles: [],
    datePicker: new Date().toISOString().substr(0, 10),
    datePickerShow: false,
    datePickerMinimum: new Date().toISOString().substr(0, 10),
    expirationDateType: null,
    locale: "en",
  }),
  created() {
    this.descriptionRules = [
      (v) => !!v || i18n.t("Description is required"),
      (v) => v.length <= 100 || i18n.t("Max 100 characters"),
    ];
  },
  watch: {
    expirationDateType(val) {
      if (val == "lifetime") {
        this.datePickerShow = false;
      } else {
        this.datePickerShow = true;
        this.datePicker = new Date().toISOString().substr(0, 10);
      }
    },
  },
  methods: {
    cleanErrorsAndTexts() {
      this.alertText = "";
      this.alertShow = false;
      this.description = "";
      this.selectedRoles = [];
    },
    sendErrorAndCloseModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }

      this.loading = false;
      this.showModal = false;
    },
    sendErrorOnModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          this.alertText = error.response.data.error;
        } else {
          this.alertText = error.response.data;
        }
      } else {
        this.alertText = error;
      }

      this.loading = false;
      this.alertShow = true;
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    show() {
      this.showModal = true;
      this.locale = this.$store.getters.locale;

      axios
        .get("/api/v1/permissions/roles?filter=id,name&gui=false")
        .then((roles) => {
          this.loading = false;
          this.cardDisabled = false;
          this.roles = roles.data.list;
        })
        .catch((error) => {
          this.sendErrorAndCloseModal(error);
        });
    },
    createToken() {
      this.loading = true;
      let data = {};

      if (this.description != "") {
        data.description = this.description;

        if (this.expirationDateType == "expirationDate") {
          data.expirationDate = this.$moment(this.datePicker, "YYYY-MM-DD")
            .add(23, "hours")
            .add(59, "minutes")
            .add(59, "seconds")
            .tz(this.$store.getters.timezone)
            .unix();
        }

        let roles = [];
        let i = 0;

        for (i = 0; i < this.selectedRoles.length; i++) {
          roles.push(this.selectedRoles[i]);
        }

        data.roles = roles;

        axios
          .post("/api/v1/permissions/token", data)
          .then((response) => {
            this.loading = false;
            this.showModal = false;
            this.cleanErrorsAndTexts();
            this.resetValidation();

            if (
              !response.data ||
              !response.data.status ||
              !(response.data.status == "done")
            ) {
              this.showModal = false;
              EventBus.$emit("SHOW_ERROR", response);
            } else {
              this.$parent.$parent.updateTable();
            }
          })
          .catch((error) => {
            this.sendErrorOnModal(error);
          });
      }
    },
    hide() {
      this.loading = false;
      this.showModal = false;
      this.cleanErrorsAndTexts();
      this.resetValidation();
    },
  },
};
</script>

<style scoped>
.v-alert {
  overflow: hidden;
}
</style>